// import "./index.scss";
import { useContext } from "react";
import utility from "src/utils/utility";
import UserContext from "src/provider/state-manager/userProvider";
import { MemberTypeEnum } from "src/model";
import { BroadcastModal } from "src/component/BroadcastMail/BroadcastModal";

const BroadcastMail = () => {
 const {user} = useContext(UserContext)
 
 return (
    <div className="dashboard-view-result">
        {user?.profile?.memberType === MemberTypeEnum.ADMIN ? (
            <BroadcastModal />
        ): null}
    </div>
 )
}

export default utility.routeData(
    "broadcast-mail",
    "Broadcast Mail",
    <BroadcastMail />
)